/** Post Comments workspace proportions — denser than Inbox, not an Inbox clone. */
export const POST_COMMENTS_LIST_WIDTH_PX = 240;
export const POST_COMMENTS_DETAILS_DOCKED_WIDTH_PX = 280;
export const POST_COMMENTS_DETAILS_DRAWER_WIDTH_PX = 300;

export const POST_COMMENTS_PAGE_CARD =
  "min-h-0 overflow-hidden rounded-xl border border-line/70 bg-surface shadow-[0_1px_2px_rgba(15,23,42,0.04)]";

export const POST_COMMENTS_HEADER_SHELL =
  "flex shrink-0 flex-wrap items-center justify-between gap-3 border-b border-line/70 bg-[linear-gradient(180deg,rgba(255,255,255,0.98)_0%,rgba(248,250,252,0.94)_100%)] px-3.5 py-3";
